import { render, staticRenderFns } from "./BankOrderPrint.vue?vue&type=template&id=4574d0ea&scoped=true"
import script from "./BankOrderPrint.vue?vue&type=script&lang=js"
export * from "./BankOrderPrint.vue?vue&type=script&lang=js"
import style0 from "./BankOrderPrint.vue?vue&type=style&index=0&id=4574d0ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4574d0ea",
  null
  
)

export default component.exports